export const MonthInputFormat = 'yyyy-MM';
export const DateInputFormat = 'yyyy-MM-dd';
export const MonthOutputFormat = 'yyyy年M月';
export const yaerOutputFormat = 'yyyy年';
export const DateOutputFormat = 'yyyy年M月d日';
export const DateOutputFormatWithSlash = 'yyyy/MM/dd';
export const DateOutputFormatWithColon = 'yyyy.MM.dd';
export const DateTimeOutputFormat = 'yyyy年MM月dd日HH時mm分';
export const DateTimeOutputFormatWithHyphen = 'yyyy-MM-dd HH:mm';
export const ChatDateTimeOutputFormatWithSlash = 'yyyy/MM/dd HH:mm';
export const DeskTopMediaQuery = '(min-width:576px)';

export const cmVideoId = 'c85DMomM5FA';

export const NotificationText = {
  error: 'エラーが発生しました',
  inaccessiblePage: 'このページはアクセスできません',
  loginFailed: 'メールアドレスまたはパスワードが間違っています',
  otpInvalid: '認証コードが違います',
  otpChallengeInvalid: '認証コードが無効になりました。もう一度ログインしてください',
  otpRateLimited: 'しばらく時間をおいて再度お試しください',
  otpAlreadyEnabled: '2段階認証はすでに有効になっています',
  passwordIncorrect: 'パスワードが正しくありません',
  invalidValue: '不正な値が入力されています',
  unfilledRequiredItems: '必須項目が入力されていません',
  successCreateAdminUser: '運営ユーザーを作成しました',
  successEditAdminUser: '運営ユーザーを編集しました',
  successDeleteAdminUser: '運営ユーザーを削除しました',
  outsourcerCodeRequired: '外注者権限を1つ以上選択してください',
  sendLoginInfoEmailSuccess: 'ログイン情報をメールで送信しました',
  sendLoginInfoEmailFailed: 'ログイン情報の送信に失敗しました',
  sendReciprocalLinkRequestEmailSuccess: '相互リンク依頼メールを送信しました',
  sendReciprocalLinkRequestEmailFailed: '相互リンク依頼メールの送信に失敗しました',
  getCompanyUsersFailed: 'ユーザー一覧の取得に失敗しました',
  successCreateAnnouncement: 'お知らせを作成しました',
  successEditAnnouncement: 'お知らせを編集しました',
  successDeleteAnnouncement: 'お知らせを削除しました',
  successDeleteProperty: '物件を削除しました',
  successDeleteChatRoom: '売却相談チャットを削除しました',
  successCreateCompanyUser: '不動産会社ユーザーを作成しました',
  successCreateMultiCompanyUser: '複数店舗ログイン用ユーザーを作成しました',
  successEditCompanyUser: '不動産会社ユーザーを編集しました',
  successDeleteCompanyUser: '不動産会社ユーザーを削除しました',
  successCreateCity: '市区町村を作成しました',
  successEditCity: '市区町村を編集しました',
  successDeleteCity: '市区町村を削除しました',
  successCreateTown: '町域を作成しました',
  successEditTown: '町域を編集しました',
  successDeleteTown: '町域を削除しました',
  successCreateMansion: 'マンションを作成しました',
  successEditMansion: 'マンションを編集しました',
  successDeleteMansion: 'マンションを削除しました',
  successRequestMansion: 'マンション作成を依頼しました',
  successCreateCompanyNotificationEmails: '通知先を作成しました',
  successDeleteCompanyNotificationEmails: '通知先を削除しました',
  successCreateCompany: '会社を作成しました',
  successEditCompany: '会社を編集しました',
  successUpdateStep: 'ステップを更新しました',
  successUpdateCompanyStrongPoint: '強みを更新しました',
  successUpdateHandlePublic: '公開状態を更新しました',
  successUpdatePurchaseAvailability: '買取対応を更新しました',
  successEditAccount: 'アカウントを編集しました',
  successEnableOtp: '2段階認証を有効にしました',
  successDisableOtp: '2段階認証を無効にしました',
  successEditSaleCase: '売却実績を編集しました',
  successDraftSaveSaleCase: '売却実績を一時保存しました',
  successSaveSaleCase: '売却実績を申請しました',
  companyNotSelected: '会社が選択されていません',
  successUpdateSaleCase: '売却実績の状態を更新しました',
  successRejectSaleCase: '売却実績を差し戻しました',
  successDeleteSaleCase: '売却実績を削除しました',
  isMediationContractDateAfterContractDate: '媒介契約日が売買契約日以降の日付になっているため、登録ができません。',
  isContractDateAfterToday: '売買契約日が実績登録日以降の日付になっているため、登録ができません。',
  checkAgreementRequired: '【注意事項】 にチェックをして下さい',
  draftSaleCaseRequiredTown: '一時保存するには町域を入力して下さい',
  successCreateAgreementReport: '売買契約報告を登録しました',
  successEditAgreementReport: '売買契約報告を編集しました',
  successDeleteAgreementReport: '売買契約報告を削除しました',
  successCreateMediationAgreementReport: '媒介契約報告を登録しました',
  successUpdateMediationAgreementReport: '媒介契約報告を更新しました',
  successEditMediationAgreementReport: '媒介契約報告を編集しました',
  successDeleteMediationAgreementReport: '媒介契約報告を削除しました',
  successUpdateCompanyInformation: '会社情報を編集しました',
  successUpdateCompanyProfile: '会社紹介文を編集しました',
  successApproveCompanyProfile: '会社紹介文を承認しました',
  successRejectedCompanyProfile: '会社紹介文を差し戻しました',
  successUpdateMainProfileImage: 'メイン写真を変更しました',
  successRequestAddImage: '写真の追加を依頼しました',
  successRequestViewInformationMap: '販売図面の取得を依頼しました',
  successUpdateMembershipStatus: '加盟状態を変更しました',
  successConvertCompany: 'コンバートを実行しました',
  interviewArticleCreated: 'インタビュー記事を作成しました',
  interviewArticleCreateFailed: 'インタビュー記事の作成に失敗しました',
  interviewArticleUpdated: 'インタビュー記事を更新しました',
  interviewArticleUpdatedFailed: 'インタビュー記事の更新に失敗しました',
  interviewArticleDeleted: 'インタビュー記事を削除しました',
  interviewArticleDeleteFailed: 'インタビュー記事の削除に失敗しました',
  interviewArticleSynced: 'microCMSから記事を同期しました',
  interviewArticleSyncFailed: 'microCMSからの同期に失敗しました',
  interviewArticlePreviewFailed: 'プレビューを開けませんでした',
  reasonFaqPageCreated: '理由別FAQページを保存しました',
  reasonFaqPageCreateFailed: '理由別FAQページの保存に失敗しました',
  reasonFaqPageUpdated: '理由別FAQページを保存しました',
  reasonFaqPageUpdateFailed: '理由別FAQページの保存に失敗しました',
  reasonFaqPagePublished: '理由別FAQページを公開しました',
  reasonFaqPagePublishFailed: '理由別FAQページを公開できませんでした',
  reasonFaqPageUnpublished: '理由別FAQページを非公開にしました',
  reasonFaqPageUnpublishFailed: '理由別FAQページの非公開に失敗しました',
  reasonFaqPageDeleted: '理由別FAQページを削除しました',
  reasonFaqPageDeleteFailed: '理由別FAQページの削除に失敗しました',
  reasonFaqPageCopiedUrl: '公開URLをコピーしました',
  aiAppraisalReportEditedContentSaved: '査定書の編集内容を保存しました',
  aiAppraisalReportEditedContentSaveFailed: '査定書の編集内容の保存に失敗しました',
  aiAppraisalReportEditedContentConflict: '他の担当者が保存しました。最新の内容を読み込みます',
  aiAppraisalReportEditedContentReset: '初稿の内容に戻しました',
  aiAppraisalReportEditedContentResetFailed: '初稿へのリセットに失敗しました',
  aiAppraisalReportEditedContentRegen: '査定価格の根拠を再生成しました',
  aiAppraisalReportEditedContentRegenFailed: '再生成に失敗しました',
  aiAppraisalReportEditedContentRegenThrottled: '再生成は30秒に1回までです。しばらく待ってから再度お試しください',
  aiAppraisalReportEditedContentLoadFailed: '編集データを取得できませんでした',
  aiAppraisalReportEditedContentNotCompleted: '査定書の作成が完了してから編集できます',
  sellerCompanyReviewCreated: '売主アンケートを作成しました',
  sellerCompanyReviewCreateFailed: '売主アンケートの作成に失敗しました',
  successDeleteSellerCompanyReview: '売主アンケートを削除しました',
  initialAutoMessageCreated: '初回自動メッセージを作成しました',
  initialAutoMessageCreateFailed: '初回自動メッセージの作成に失敗しました',
  staffProfileCreated: 'スタッフを作成しました',
  staffProfileCreateFailed: 'スタッフの作成に失敗しました',
  staffProfileUpdated: 'スタッフを更新しました',
  staffProfileUpdateFailed: 'スタッフの更新に失敗しました',
  staffProfileDeleted: 'スタッフを削除しました',
  staffProfileDeleteFailed: 'スタッフの削除に失敗しました',
  successLastMonthMembershipAnnouncement: '公開催促メールを送信しました',
  successAddImage: '写真を追加しました',
  successApproveImage: '写真を承認しました',
  successRejectImage: '写真を差し戻しました',
  successDeleteProfileImage: '写真を削除しました',
  successUpdateCompanyTags: 'タグ情報を保存しました',
  successActivateIqloud: 'イクラウドに加盟しました',
  successActivateLeaseback: 'リースバックに加盟しました',
  successActivatePro: 'PROに加盟しました',
  successActivateEmbedMap: '埋め込み地図に加盟しました',
  successActivateSellingPage: '売却LPに加盟しました',
  successActivateAiAppraisal: 'AI査定に加盟しました',
  successActivateVisitReservation: '来店予約に加盟しました',
  successActivateUserVoice: '口コミ連動に加盟しました',
  successActivatePurchaseAgencySearch: '買取会社検索に加盟しました',
  successCreateFreeMap: '無料マップを発行しました',
  successUpdateTopTitles: '検索軸別アピール文を更新しました。',
  successSubmitEmail: 'メールを送信しました',
  successForcePublish: '運営公開しました',
  successInactiveCompanyService: '解約しました',
  successUpdateAiAppraisalPlan: 'AI査定書のプランを変更しました',
  aiAppraisalServiceNotActive: 'AI査定サービスが有効化されていません',
  emailNotFound: 'このメールアドレスは登録されていません',
  resetPassword: 'パスワードを再設定しました',
  tokenExpired: 'こちらのURLは期限が切れています。',
  hasInvalidReformItem: '入力が不完全なリフォーム項目があります',
  successStartPurchaseChat: '買取会社とのチャットを作成しました',
  successDeleteSellerUser: '売主を退会・削除しました',
  successRefreshCash: 'キャッシュの更新に成功しました',
  failedRefreshCash: 'キャッシュの更新に失敗しました',
  successCreateMessageTemplate: 'チャットテンプレートを登録しました',
  failedCreateMessageTemplate: 'チャットテンプレートの登録に失敗しました',
  successUpdateMessageTemplate: 'チャットテンプレートの編集に成功しました',
  failedUpdateMessageTemplate: 'チャットテンプレートの編集に失敗しました',
  successDeleteMessageTemplate: 'チャットテンプレートを削除しました',
  failedDeleteMessageTemplate: 'チャットテンプレートの削除に失敗しました',
  successCreateExistingSellerReport: '既存顧客報告を申請しました',
  successDeleteExistingSellerReport: '既存顧客報告を取り消しました',
  successReportNewCustomerOfflineSellerLead: '新規顧客として運営に通知しました',
  buyingRequiredTexts: '販売図面・物件情報等資料の補足事項を入力してください',
  successEditAiAppraisalReport: 'AI査定書を更新しました',
  successApplyAiAppraisalReportRoadPrice: '路線価を登録し、AI査定書の作成を再開しました',
  successRefreshCsCmsPage: 'CMSページを更新しました',
  failedRefreshCsCmsPage: 'CMSページの更新に失敗しました',
  successSyncAllCsCmsPages: 'microCMSとの全件同期を実行しました',
  failedSyncAllCsCmsPages: '全件同期に失敗しました',
  successCopyShareUrl: 'URLをコピーしました',
  successCreateSellingLpContent: '売却LPコンテンツを作成しました',
  successEditSellingLpContent: '売却LPコンテンツを更新しました',
  successDeleteSellingLpContent: '売却LPコンテンツを削除しました',
  successCreatePenaltyApplicationDraft: 'ペナルティ申請を下書き保存しました',
  successSubmitPenaltyApplication: 'ペナルティ申請を申請しました',
  successEditPenaltyApplication: 'ペナルティ申請を更新しました',
  successApprovePenaltyApplication: 'ペナルティ申請を承認しました',
  successRejectPenaltyApplication: 'ペナルティ申請を却下しました',
  successDeletePenaltyApplication: 'ペナルティ申請を削除しました',
  confirmApprovePenaltyApplication: '承認すると、ペナルティポイントが会社に自動付与されます。承認しますか？',
  requireDecisionReasonForReject: '却下する場合は判定理由を入力してください',
} as const;

export const ValidationText = {
  required: 'こちらの入力は必須です',
  requeuedSelect: 'こちらの選択は必須です',
  invalidZipCode: '郵便番号のフォーマットが違います',
  invalidEmail: '正しいメールアドレスを入力して下さい',
  takenEmail: 'このメールアドレスは使用されています',
  mismatchedPassword: 'パスワードが一致しません',
  invalidIntegerNumber: '半角で整数を入力して下さい',
  invalidNumber: '半角数字を入力して下さい',
  invalidPriceFormat10k: '万単位で入力して下さい',
  invalidFloatNumber: '半角数字を小数点以下4桁以内で入力して下さい',
  invalidFloorPlan: '間取りの入力フォーマットが違います',
  invalidTelPhoneNumber: '無効な電話番号です',
  passwordMinLength: 'パスワードは8文字以上を入力して下さい。',
  prefectureRequired: '都道府県を選択して下さい',
  cityRequired: '市区町村を選択して下さい',
  townRequired: '町域まで選択して下さい',
  financialAgencyRequired: '金融機関を選択して下さい',
};

export const ScheduledMessageErrorText = {
  createFailed: '予約投稿の設定に失敗しました。',
  updateFailed: '予約投稿の更新に失敗しました。',
  cancelFailed: '予約投稿の取り消しに失敗しました。',
};

export const CancelReason = {
  seller_cancelled: '退会',
  admin_cancelled_duplicate_registration: '重複登録削除',
  admin_cancelled_same_business_person: '同業者削除',
  other: 'その他',
};

export const ChatPropertyDiscardReason = {
  seller_cancelled: '退会',
  duplicate_registration: '重複登録削除',
};

export const CompanyStep = {
  created: '作成中',
  preparing: '準備中',
  inputting: '入力中',
  completed: '登録完了',
};

export const CompanyType = {
  general_agency: '仲介会社',
  purchase_agency: '買取専門会社',
};

export const CommissionRateTypeKey = {
  standard: '通常',
  c21: 'センチュリー21',
  asolie: 'ASOLIE',
};

export const AgreementReportFileType = {
  sales_agreement: '売買契約書',
  commission_receipt: '仲介手数料領収書または仲介手数料の支払約定書',
  mediation_agreement: '媒介契約書',
};

export const MansionStatus = {
  available: '公開',
  closed: '非公開',
  requested: '確認依頼',
};

//TODO:iqloudにもあるので対応相談
export const BuildingStructures = {
  wooden: '木造',
  light_steel: '軽量鉄骨造',
  steel: '(重量)鉄骨造',
  rc: '鉄筋コンクリート',
  src: '鉄骨鉄筋コンクリート',
  cb: 'コンクリートブロック',
};

export const BuildingCompany = {
  house_maker: 'ハウスメーカー',
  not_house_maker: 'ハウスメーカー以外',
};

//TODO:iqloudにもあるので対応相談
export const LandRight = {
  ownership: '所有権',
  leasehold: '借地権',
  other_land_rights: 'その他',
};

//TODO:iqloudにもあるので対応相談
export const DealType = {
  mediation: '売り仲介',
  purchase: '買取',
};

export const dealTypeSelectItems = {
  ...DealType,
  buying_and_selling: '売買両手',
  buying: '買い仲介',
};

export const PurchaseType = {
  other_company: '買取会社への仲介',
  in_house: '自社買取',
};

export const SecureFileType = {
  purchase_offer_letter: '買付証明書',
  other: 'その他（売買契約書、取引台帳）',
} as const;

export type SecureFileTypeKeys = keyof typeof SecureFileType;

export const DealAndPurchaseType = {
  mediation: '仲介',
  ...PurchaseType,
  buying_and_selling: '売買両手',
  buying: '買い仲介',
};

export const DealAndPurchaseTypeAnnotations = {
  in_house:
    '※​「自社買取」​「買取会社への​仲介」で​登録した​物件の​金額や​詳細は​お客様が​見る​ページに​表示は​されません。',
  other_company:
    '※​「自社買取」​「買取会社への​仲介」で​登録した​物件の​金額や​詳細は​お客様が​見る​ページに​表示は​されません。',
  buying_and_selling: '※買主が業者の場合は、「買取会社への仲介」をご選択ください。',
  buying: '※​「買い仲介」は​自社HPの​マップに​のみ​反映されます。',
} as const;

//TODO:iqloudにもあるので対応相談
export const PropertyType = {
  mansion: 'マンション',
  land: '土地',
  used_house: '中古戸建て',
  new_house: '新築戸建て',
};

export const AiAppraisalPropertyType = {
  land: '土地',
  house: '戸建て',
};

//TODO:iqloudにもあるので対応相談
export const ResidenceCurrentStatus = {
  residence: '居住中',
  rented: '賃貸中',
  vacant: '空室',
};

export type ResidenceCurrentStatusKeys = keyof typeof ResidenceCurrentStatus;

//TODO:iqloudにもあるので対応相談
export const LandCurrentStatus = {
  vacant: '更地',
  with_old_house: '古家あり',
  other_current_statuses: 'その他',
};
export type LandCurrentStatusKeys = keyof typeof LandCurrentStatus;

export const LandCategory = {
  residential: '宅地',
  paddy: '田',
  farm: '畑',
  forest: '山林',
  other: 'その他（雑種地含む）',
};
export type LandCategoryKeys = keyof typeof LandCategory;

//TODO:iqloudにもあるので対応相談
export const MediateType = {
  selling: '売り手',
  buying: '買い手',
  buying_and_selling: '売買両手',
  lending: '貸し手',
  borrowing: '借り手',
  lending_and_borrowing: '貸借両手',
};
//TODO:iqloudにもあるので対応相談
//1のときだけ選択肢に1Rあり
export const FloorPlan = {
  option1: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  option2: ['K', 'DK', 'LDK', 'SDK', 'SLDK'],
  option3: ['R', 'K', 'DK', 'LDK', 'SDK', 'SLDK'],
};

export const OccupiedAreaType = {
  wall_core: '壁芯',
  inside: '内法',
};

export const PulldownPropertyType = {
  '': '全て',
  mansion: 'マンション',
  land: '土地',
  used_house: '中古戸建て',
  new_house: '新築戸建て',
};

export const SaleCasesStatusType = {
  draft: '一時保存',
  unapproved: '承認待ち',
  approved: '承認済み',
  rejected: '差し戻し',
};

export const PulldownSaleCasesStatusType = {
  '': '全て',
  ...SaleCasesStatusType,
};

export const SaleCasesSortKey = {
  price: '売買価格',
  created_at: 'アップロード日',
  contract_date: '売買契約締結日',
  land_area: '土地面積',
};

export const ProfileImageStatusType = {
  unapproved: '未承認',
  approved: '承認済み',
  rejected: '差し戻し',
};

export const ManagementType = {
  consignment: '委託',
  self_management: '自主管理',
  unknown: '不明',
};

export const BillingStatus = {
  unclaimed: '未請求',
  billed: '請求済み',
  paid: '支払い済み',
};

export const ReformTimingOptions = {
  specific_year: '',
  recently: '時期不明（５年以内）',
  unknown: '時期不明',
};

export const DashboardSaleCaseFinalSaveRequiredFormKeys = {
  mansion: [
    'mansion_id',
    'contract_date',
    'price',
    'occupied_area',
    'floor',
    'room_number',
    'floor_plan',
    'current_status',
    'information_map',
  ],
  land: [
    'town_code',
    'address',
    'contract_date',
    'price',
    'current_status',
    'land_area',
    'land_area_detail',
    'architectural_condition',
    'information_map',
  ],
  used_house: [
    'town_code',
    'address',
    'contract_date',
    'price',
    'floor',
    'floor_plan',
    'current_status',
    'land_area',
    'land_area_detail',
    'building_area',
    'building_structure',
    'land_right',
    'home_inspection',
    'information_map',
  ],
  new_house: [
    'town_code',
    'address',
    'contract_date',
    'price',
    'floor',
    'floor_plan',
    'land_area',
    'land_area_detail',
    'building_area',
    'building_structure',
    'land_right',
    'information_map',
  ],
};

export const DashboardSaleCaseValidationLabels: { [key: string]: string } = {
  company_id: '会社ID',
  contract_date: '売買契約締結日',
  price: '売買価格',
  sale_reasons: '売却理由',
  information_map: 'マイソク',
  town: '町域',
  town_code: '町域',
  address: '町域以下',
  mansion_id: 'マンション',
  building_structure: '建物構造',
  built_date: '建築年月',
  mediation_contract_date: '媒介契約締結日',
  floor: '階数',
  occupied_area: '専有面積',
  current_status: '現況・状態',
  room_number: '部屋番号',
  floor_plan: '間取り',
  building_area: '建物面積',
  rejected_reason: '差し戻し理由',
  land_right: '土地権利',
  land_area: '土地面積',
};

export const ValidationLabels = [
  {
    formName: 'code',
    label: 'コード',
  },
  {
    formName: 'company_id',
    label: '会社ID',
  },
  {
    formName: 'status',
    label: '登録ステータス',
  },
  {
    formName: 'email',
    label: 'メールアドレス',
  },
  {
    formName: 'zipcode',
    label: '郵便番号',
  },
  {
    formName: 'town_code',
    label: '町域コード',
  },
  {
    formName: 'address',
    label: '住所',
  },
  {
    formName: 'nearest_station',
    label: '最寄駅',
  },
  {
    formName: 'management_company',
    label: '管理会社',
  },
  {
    formName: 'management_type',
    label: '管理形態',
  },
  {
    formName: 'use_district',
    label: '用途地域',
  },
  {
    formName: 'building_structure',
    label: '建物構造',
  },
  {
    formName: 'built_date',
    label: '建築年月',
  },
  {
    formName: 'ground_floors',
    label: '地上階数',
  },
  {
    formName: 'underground_floors',
    label: '地下階数',
  },
  {
    formName: 'total_units',
    label: '総戸数',
  },
  {
    formName: 'former_for_sale_owner',
    label: '旧分譲主',
  },
  {
    formName: 'construction_company',
    label: '施工会社',
  },
  {
    formName: 'price',
    label: '売買価格',
  },
  {
    formName: 'contract_date',
    label: '売買契約締結日',
  },
  {
    formName: 'mediation_contract_date',
    label: '媒介契約締結日',
  },
  {
    formName: 'sale_reasons',
    label: '売却理由',
  },
  {
    formName: 'floor',
    label: '階数',
  },
  {
    formName: 'occupied_area',
    label: '専有面積',
  },
  {
    formName: 'mansion_id',
    label: 'マンション',
  },
  {
    formName: 'current_status',
    label: '現況・状態',
  },
  {
    formName: 'room_number',
    label: '部屋番号',
  },
  {
    formName: 'floor_plan',
    label: '間取り',
  },
  {
    formName: 'building_area',
    label: '建物面積',
  },
  {
    formName: 'rejected_reason',
    label: '差し戻し理由',
  },
  {
    formName: 'land_right',
    label: '土地権利',
  },
  {
    formName: 'land_area',
    label: '土地面積',
  },
  {
    formName: 'tel',
    label: '電話番号',
  },
  {
    formName: 'fax',
    label: 'FAX番号',
  },
  {
    formName: 'lat',
    label: '緯度',
  },
  {
    formName: 'long',
    label: '経度',
  },
  {
    formName: 'url',
    label: 'ホームページURL',
  },
  {
    formName: 'reciprocal_link_url',
    label: '相互リンク設置ホームページURL',
  },
  {
    formName: 'top_title',
    label: 'アピールポイント',
  },
  {
    formName: 'title_first',
    label: '会社紹介タイトル１',
  },
  {
    formName: 'body_first',
    label: '会社紹介文１',
  },
  {
    formName: 'reform_items',
    label: 'リフォーム履歴',
  },
  {
    formName: 'property_full_address',
    label: '物件所在地',
  },
  {
    formName: 'appraisal_price',
    label: '相場価格',
  },
  {
    formName: 'land_price_per_sqm',
    label: '土地価格（㎡単価）',
  },
  {
    formName: 'land_price_per_tsubo',
    label: '土地価格（坪単価）',
  },
  {
    formName: 'property_full_lot_number_address',
    label: '物件所在地（地番）',
  },
  {
    formName: 'property_property_type',
    label: '物件種別',
  },
  {
    formName: 'property_land_area',
    label: '土地面積（㎡）',
  },
  {
    formName: 'property_building_area',
    label: '建物面積（㎡）',
  },
  {
    formName: 'property_land_area_tsubo',
    label: '土地面積（坪）',
  },
  {
    formName: 'property_building_area_tsubo',
    label: '建物面積（坪）',
  },
  {
    formName: 'property_built_year',
    label: '建築年',
  },
  {
    formName: 'property_building_structure',
    label: '建物構造',
  },
  {
    formName: 'property_floor',
    label: '階数',
  },
  {
    formName: 'property_land_right',
    label: '土地権利',
  },
  {
    formName: 'land_price',
    label: '予想土地相場価格',
  },
  {
    formName: 'building_price',
    label: '予想建物相場価格',
  },
  {
    formName: 'zone_flood_inundation',
    label: '洪水浸水想定区域',
  },
  {
    formName: 'zone_sediment_disaster',
    label: '土砂災害警戒区域',
  },
  {
    formName: 'zone_disaster_alert',
    label: '災害警戒区域',
  },
  {
    formName: 'zone_steep_slope_hazard',
    label: '急傾斜地崩壊危険区域',
  },
  {
    formName: 'zone_landslide_prevention',
    label: '地すべり防止地区',
  },
  {
    formName: 'zone_urban_planning',
    label: '都市計画区域',
  },
  {
    formName: 'zoning_category',
    label: '区域区分',
  },
  {
    formName: 'use_district',
    label: '用途地域',
  },
  {
    formName: 'building_coverage_ratio',
    label: '建ぺい率',
  },
  {
    formName: 'floor_area_ratio',
    label: '容積率',
  },
  {
    formName: 'area_fire_prevention',
    label: '防火・準防火地域',
  },
  {
    formName: 'district_plan',
    label: '地区計画',
  },
  {
    formName: 'location_optimization_plan',
    label: '立地適正化計画',
  },
  {
    formName: 'road_access',
    label: '道路付',
  },
  {
    formName: 'sale_case_full_address',
    label: '実績の所在地',
  },
  {
    formName: 'sale_case_contract_date',
    label: '実績の売買契約締結日',
  },
  {
    formName: 'sale_case_price',
    label: '実績の成約価格',
  },
  {
    formName: 'sale_case_property_type',
    label: '実績の物件種別',
  },
  {
    formName: 'sale_case_land_area',
    label: '実績の土地面積（㎡）',
  },
  {
    formName: 'sale_case_land_right',
    label: '実績の土地権利',
  },
  {
    formName: 'sale_case_road_access',
    label: '実績の道路付',
  },
  {
    formName: 'sale_case_land_price_per_sqm',
    label: '実績の土地価格（㎡単価）',
  },
  {
    formName: 'sale_case_land_area_tsubo',
    label: '実績の土地面積（坪）',
  },
  {
    formName: 'sale_case_land_price_per_tsubo',
    label: '実績の土地価格（坪単価）',
  },
  {
    formName: 'property_lat',
    label: '査定物件の緯度',
  },
  {
    formName: 'property_long',
    label: '査定物件の経度',
  },
  {
    formName: 'sale_case_lat',
    label: '実績の緯度',
  },
  {
    formName: 'sale_case_long',
    label: '実績の経度',
  },
  {
    formName: 'about_appraisal_text_first',
    label: '査定の根拠の文章1',
  },
  {
    formName: 'about_appraisal_text_second',
    label: '査定の根拠の文章2',
  },
  {
    formName: 'about_appraisal_text_third',
    label: '査定の根拠の文章3',
  },
  {
    formName: 'about_base_house_text',
    label: '建物部分の価値について',
  },
  {
    formName: 'final_text',
    label: '総額の予測査定額',
  },
  {
    formName: 'information_map',
    label: '販売図面・物件情報等資料(マイソク)',
  },
  {
    formName: 'secure_file',
    label: '買付証明書等の資料',
  },
  {
    formName: 'architectural_condition',
    label: '建築条件の有無',
  },
  {
    formName: 'land_category',
    label: '土地地目',
  },
  {
    formName: 'occupied_area_type',
    label: '専有面積の区分',
  },
  {
    formName: 'home_inspection',
    label: '住宅診断',
  },
  {
    formName: 'purchase_type',
    label: '購入タイプ',
  },
  {
    formName: 'inhouse_agent_name',
    label: '自社の客付担当者名',
  },
  {
    formName: 'listing_company_name',
    label: '元付会社名',
  },
  {
    formName: 'listing_agent_name',
    label: '元付会社の担当者名',
  },
  {
    formName: 'secure_file_type',
    label: '添付資料の種類',
  },
  {
    formName: 'mediate_type',
    label: '仲介タイプ',
  },
];

export const PrefecturesWithAll: { [key: number]: string } = {
  0: '全て',
  1: '北海道',
  2: '青森県',
  3: '岩手県',
  4: '宮城県',
  5: '秋田県',
  6: '山形県',
  7: '福島県',
  8: '茨城県',
  9: '栃木県',
  10: '群馬県',
  11: '埼玉県',
  12: '千葉県',
  13: '東京都',
  14: '神奈川県',
  15: '新潟県',
  16: '富山県',
  17: '石川県',
  18: '福井県',
  19: '山梨県',
  20: '長野県',
  21: '岐阜県',
  22: '静岡県',
  23: '愛知県',
  24: '三重県',
  25: '滋賀県',
  26: '京都府',
  27: '大阪府',
  28: '兵庫県',
  29: '奈良県',
  30: '和歌山県',
  31: '鳥取県',
  32: '島根県',
  33: '岡山県',
  34: '広島県',
  35: '山口県',
  36: '徳島県',
  37: '香川県',
  38: '愛媛県',
  39: '高知県',
  40: '福岡県',
  41: '佐賀県',
  42: '長崎県',
  43: '熊本県',
  44: '大分県',
  45: '宮崎県',
  46: '鹿児島県',
  47: '沖縄県',
};

export const PrefecturesForLicense: { [key: number]: string } = {
  1: '北海道知事免許',
  2: '青森県知事免許',
  3: '岩手県知事免許',
  4: '宮城県知事免許',
  5: '秋田県知事免許',
  6: '山形県知事免許',
  7: '福島県知事免許',
  8: '茨城県知事免許',
  9: '栃木県知事免許',
  10: '群馬県知事免許',
  11: '埼玉県知事免許',
  12: '千葉県知事免許',
  13: '東京都知事免許',
  14: '神奈川県知事免許',
  15: '新潟県知事免許',
  16: '富山県知事免許',
  17: '石川県知事免許',
  18: '福井県知事免許',
  19: '山梨県知事免許',
  20: '長野県知事免許',
  21: '岐阜県知事免許',
  22: '静岡県知事免許',
  23: '愛知県知事免許',
  24: '三重県知事免許',
  25: '滋賀県知事免許',
  26: '京都府知事免許',
  27: '大阪府知事免許',
  28: '兵庫県知事免許',
  29: '奈良県知事免許',
  30: '和歌山県知事免許',
  31: '鳥取県知事免許',
  32: '島根県知事免許',
  33: '岡山県知事免許',
  34: '広島県知事免許',
  35: '山口県知事免許',
  36: '徳島県知事免許',
  37: '香川県知事免許',
  38: '愛媛県知事免許',
  39: '高知県知事免許',
  40: '福岡県知事免許',
  41: '佐賀県知事免許',
  42: '長崎県知事免許',
  43: '熊本県知事免許',
  44: '大分県知事免許',
  45: '宮崎県知事免許',
  46: '鹿児島県知事免許',
  47: '沖縄県知事免許',
  99: '国土交通大臣免許',
};

//チャット売却物件種別
export const ChatPropertyType = {
  mansion: 'マンション一室',
  land: '土地',
  used_house: '戸建て',
  terrace_house: 'テラスハウス',
  commercial: '店舗・事務所・倉庫',
  mansion_building: 'マンション一棟',
  apartment_building: 'アパート一棟',
  office_building: 'ビル一棟',
};

export const PullDownChatPropertyType = {
  '': '全て',
  mansion: 'マンション一室',
  land: '土地',
  used_house: '戸建て',
  terrace_house: 'テラスハウス',
  commercial: '店舗・事務所・倉庫',
  mansion_building: 'マンション一棟',
  apartment_building: 'アパート一棟',
  office_building: 'ビル一棟',
};

export const ChatValidationText = {
  required: 'こちらの入力は必須です',
  need_property: 'こちらの入力は必須です',
  invalidIntegerNumber: '半角数字を入力して下さい',
  invalidFloatNumber: '半角数字を小数点以下4桁以内で入力して下さい',
  noteLimit: '450文字以内で入力して下さい',
  reformLimit: '1000文字以内で入力して下さい',
  adminAdditionalInfoLimit: '1000文字以内で入力して下さい',
};

export const ChatFloorPlanSelectList = {
  '1R(ワンルーム)': '1R(ワンルーム)',
  '1K/1DK': '1K/1DK',
  '1LK/1LDK': '1LK/1LDK',
  '2K/2DK': '2K/2DK',
  '2LK/2LDK': '2LK/2LDK',
  '3K/3DK': '3K/3DK',
  '3LK/3LDK': '3LK/3LDK',
  '4K/4DK': '4K/4DK',
  '4LK/4LDK': '4LK/4LDK',
  '5K/5DK': '5K/5DK',
  '5LK/5LDK': '5LK/5LDK',
  '6K/6DK': '6K/6DK',
  '6LK/6LDK': '6LK/6LDK',
  '6LK/6LDK以上': '6LK/6LDK以上',
  other: 'その他',
  unknown: '不明',
};

export type ChatFloorPlanSelectListKeys = keyof typeof ChatFloorPlanSelectList;

//チャットステータス
export const ChatRoomStatus = {
  before_start: 'チャット開始前',
  started: 'チャット開始済',
  completed_assessment: '訪問査定済',
  made_mediation_contract: '媒介契約済',
  made_contract: '売買契約済',
  completed_deal: '売却完了',
  pending: '保留中',
  cancelled: '売却完了',
};

export const PullDownChatRoomStatus = {
  '': '全て',
  before_start: 'チャット開始前',
  started: 'チャット開始済',
  completed_assessment: '訪問査定済',
  made_mediation_contract: '媒介契約済',
  made_contract: '売買契約済',
  completed_deal: '売却完了',
  pending: '保留中',
  cancelled: '売却完了',
};

export type PullDownChatRoomStatusKeys = keyof typeof PullDownChatRoomStatus;

//登録物件項目が必要な物件種別
export type PropertyTypeList = Array<keyof typeof ChatPropertyType>;

export const allPropertyTypes: PropertyTypeList = [
  'mansion',
  'land',
  'used_house',
  'terrace_house',
  'commercial',
  'mansion_building',
  'apartment_building',
  'office_building',
];

//step2
export const mansionNamePropertyTypeList: PropertyTypeList = [
  'mansion',
  'mansion_building',
  'apartment_building',
  'office_building',
];

export const floorPropertyTypeList: PropertyTypeList = [
  'mansion',
  'mansion_building',
  'apartment_building',
  'office_building',
];

export const totalUnitsPropertyTypeList: PropertyTypeList = ['mansion_building', 'apartment_building'];

export const roomNumberPropertyTypeList: PropertyTypeList = ['mansion'];

export const occupiedAreaPropertyTypeList: PropertyTypeList = ['mansion'];

export const floorPlanPropertyTypeList: PropertyTypeList = ['mansion', 'used_house', 'terrace_house', 'commercial'];

export const builtYearPropertyTypeList: PropertyTypeList = [
  'mansion',
  'used_house',
  'terrace_house',
  'commercial',
  'mansion_building',
  'apartment_building',
  'office_building',
];

export const reformPropertyTypeList: PropertyTypeList = [
  'mansion',
  'used_house',
  'terrace_house',
  'commercial',
  'mansion_building',
  'apartment_building',
  'office_building',
];

export const landAreaPropertyTypeList: PropertyTypeList = [
  'land',
  'used_house',
  'terrace_house',
  'commercial',
  'mansion_building',
  'apartment_building',
  'office_building',
];

export const buildingAreaPropertyTypeList: PropertyTypeList = [
  'used_house',
  'terrace_house',
  'commercial',
  'mansion_building',
  'apartment_building',
  'office_building',
];

//step3
export const landCurrentStatusPropertyTypeList: PropertyTypeList = ['land'];

export const buildingCurrentStatusPropertyTypeList: PropertyTypeList = [
  'mansion',
  'used_house',
  'terrace_house',
  'commercial',
  'mansion_building',
  'apartment_building',
  'office_building',
];

export const loanBalancePropertyTypeList: PropertyTypeList = allPropertyTypes;

export const ownerShipPropertyTypeList: PropertyTypeList = allPropertyTypes;

export const saleReasonsPropertyTypeList: PropertyTypeList = allPropertyTypes;

export const preferredTimingPropertyTypeList: PropertyTypeList = allPropertyTypes;

export const inConsultationPropertyTypeList: PropertyTypeList = allPropertyTypes;

// Property types for which each item is required.
// Display lists above decide whether an item is shown; these lists decide whether it is required.
// An item shown for a property type that is not in its required list is optional.

//step2
export const requiredMansionNamePropertyTypeList: PropertyTypeList = mansionNamePropertyTypeList;

export const requiredFloorPropertyTypeList: PropertyTypeList = [];

export const requiredTotalUnitsPropertyTypeList: PropertyTypeList = [];

export const requiredRoomNumberPropertyTypeList: PropertyTypeList = roomNumberPropertyTypeList;

export const requiredOccupiedAreaPropertyTypeList: PropertyTypeList = occupiedAreaPropertyTypeList;

export const requiredFloorPlanPropertyTypeList: PropertyTypeList = [];

export const requiredBuiltYearPropertyTypeList: PropertyTypeList = [];

export const requiredReformPropertyTypeList: PropertyTypeList = [];

export const requiredLandAreaPropertyTypeList: PropertyTypeList = landAreaPropertyTypeList;

export const requiredBuildingAreaPropertyTypeList: PropertyTypeList = buildingAreaPropertyTypeList;

//step3
export const requiredLandCurrentStatusPropertyTypeList: PropertyTypeList = [];

export const requiredBuildingCurrentStatusPropertyTypeList: PropertyTypeList = [];

export const requiredLoanBalancePropertyTypeList: PropertyTypeList = loanBalancePropertyTypeList;

export const requiredOwnerShipPropertyTypeList: PropertyTypeList = [];

export const requiredSaleReasonsPropertyTypeList: PropertyTypeList = [];

export const requiredPreferredTimingPropertyTypeList: PropertyTypeList = preferredTimingPropertyTypeList;

export const requiredInConsultationPropertyTypeList: PropertyTypeList = [];

// chat-profile-gender
export const ChatProfileGender = {
  male: '男性',
  female: '女性',
  other_genders: 'その他',
};

export const ChatType = {
  selling_room: '売却相談',
  inquiry_seller: '売主×運営',
  inquiry_company: '不動産会社×運営',
  inquiry_financial_agency_division: 'LB事業者×運営',
  consulting_room: 'LB事業者×不動産会社',
  seller_financial_agency_division_room: 'LB事業者×LB売主',
  seller_company_room: 'LB売主×紹介元不動産会社',
};

export const ConsultingProgress = {
  before_considering_selling: '売却検討前',
  only_registration_with_consultation: 'ユーザー登録のみ(相談あり)',
  only_registration_without_consultation: 'ユーザー登録のみ(相談なし)',
  registration_property_with_consultation: '物件情報まで登録済(反応あり)',
  registration_property_without_consultation: '物件情報まで登録済(反応なし)',
  started_selling_chat: '売却相談開始済',
};

export const MatchingType = {
  user_selected: '自分で選択',
  admin_assigned: '運営が追加',
  unknown: '不明',
};

export const RefererEvent = {
  selling_consultation_with_company: '不動産会社相談(会社選択)',
  selling_consultation_without_company: '不動産会社相談(会社未選択)',
  inquiry_to_iqra: '運営相談',
  inquiry_from_general_ad_lp: '汎用広告LP',
  selling_consultation_from_ad_lp: '広告LP経由不動産会社相談',
  price_simulator: 'シミュレーター',
  leaseback: 'リースバック',
  admin_registration_via_tel: '電話誘導',
  inquiry_from_cm_lp: 'CMLP経由運営相談',
  inquiry_from_al_lp_age_technologies: 'アライアンスLP経由運営相談',
  visit_reservation: '来店予約',
  visit_appraisal_reservation: '訪問査定予約',
  price_simulator_from_simulator_ad_lp: '査定広告経由運営査定',
};

export const Priority = {
  high: '高',
  middle: '中',
  low: '低',
};

export const SellerSurveyExcluded = {
  false: '除外しない',
  true: '除外する',
};

export const OfflineSellerRegistrationSource = {
  kamakura_shinsho: '鎌倉新書',
  emimen: '笑美面',
  phone: '電話',
  lelien: 'ルリアン',
};

export const EXISTING_CUSTOMER_CHECK_SOURCES: (keyof typeof OfflineSellerRegistrationSource)[] = [
  'kamakura_shinsho',
  'lelien',
];

// Mirrors OfflineSeller::Label enum values on the API side.
// `leaseback` and `registration_only` are intentionally omitted for offline sellers.
export const OfflineSellerLabel = {
  response_pending: '未対応',
  mediation_requested: '仲介希望',
  purchase_requested: '買取希望',
  both_requested: '仲介&買取',
  gift_scheduled: 'プレゼント送付予定',
  receipt_pending: '受領書返送待ち',
  action_required: '要対応',
  seller_trial_ongoing: 'Seller施策実行中',
  existing_listing: '既存掲載あり',
  other_company_listing: '他社掲載あり',
  listing_unconfirmed: '掲載未確認',
  multiple_properties: '複数物件あり',
  company_search_request: '不動産会社探し依頼',
};

// Main status (OfflineSeller::Lead#main_status) values shown in the offline seller search dropdown.
export const OfflineSellerMainStatus = {
  waiting_for_referral: '送客待ち',
  company_selected: '送客済み',
  desk_appraisal_completed: '机上査定済み',
  schedule_for_on_site_appraisal: '訪問査定予定',
  on_site_appraisal_completed: '訪問査定済',
  schedule_for_mediation_contract: '媒介契約締結予定',
  mediation_contract_completed: '媒介契約締結済',
  schedule_for_selling_contract: '売買契約締結予定',
  schedule_for_settlement: '決済待ち',
  settlement_completed: '決済済み',
  not_for_sale_by_company: '不動産会社都合で売却不可',
  not_for_sale_by_seller_user: '売主都合で売却不可',
  selling_by_other_company: '売却中他社',
  sold_confirmed_unknown_company: '成約確認済(会社不明)',
  sold_by_other_company: '成約他社',
  sale_pending: '保留中',
  situation_unknown: '状況不明',
};

export const OfflineSellerPropertyType = {
  mansion: 'マンション',
  land: '土地',
  used_house: '一戸建て',
  terrace_house: 'テラスハウス',
  commercial: '店舗・事務所・倉庫',
  mansion_building: 'マンション（一棟）',
  apartment_building: 'アパート（一棟）',
  office_building: 'オフィスビル',
};

export const OnboardingStatus = {
  user_registered: 'ユーザー登録済み',
  property_registered: '物件登録済み',
  company_selected: '会社選択済み',
  completed: '完了',
};

// 売却進捗
export const SellingStatus = {
  company_selected: '送客済',
  not_for_sale_by_company: '不動産会社都合で売却不可',
  not_for_sale_by_seller_user: '売主都合で売却不可',
  situation_unknown: '状況不明',
  sale_pending: '保留中',
  chat_started: 'チャット開始済',
  desk_appraisal_completed: '机上査定済',
  schedule_for_on_site_appraisal: '訪問査定予定',
  on_site_appraisal_completed: '訪問査定済',
  selling_by_other_company: '売却中他社',
  schedule_for_mediation_contract: '媒介契約締結予定',
  mediation_contract_completed: '媒介契約締結済み',
  schedule_for_selling_contract: '売買契約締結予定',
  sold_confirmed_unknown_company: '成約確認済(会社不明)',
  sold_by_other_company: '成約他社',
  schedule_for_settlement: '決済待ち',
  settlement_completed: '決済済み',
};

export const PullDownSellingStatus = {
  '': '全て',
  ...SellingStatus,
};

export type PullDownSellingStausKey = keyof typeof PullDownSellingStatus;

// 売却相談進捗 - 状況変更理由
export const SellingStatusChangeReportReason = {
  appraisal_completed: '査定実施済み',
  consultation_withdrawn: '相談取り下げ',
  sale_cancelled: '売却を中止',
  sold_by_other_company: '他社で成約',
  settlement_completed: '決済済み',
  other: 'その他',
};

//売却希望時期
export const PreferredTiming = {
  immediately: 'すぐに現金化したい',
  within_3_months: '3ヶ月以内',
  within_6_months: '半年以内',
  within_a_year: '1年以内',
  more_than_a_year: '1年以上先',
  nothing: 'すぐには売却を考えていない',
};

export const hasDocumentUploadedStatus = {
  all: '全て',
  true: '有り',
  false: '無し',
};

export const VisitReservationBookingStatus = {
  '': '全て',
  active: '予約済み',
  cancelled: 'キャンセル済み',
};

export const VisitReservationBookingSortKey = {
  scheduled_at: '予約日',
  id: '予約ID',
};

export const PullDownVisitAppraisalReservationStatus = {
  '': '全て',
  proposing: '打診中',
  adjusting: '調整中',
  re_adjusting: '再調整中',
  confirmed: '確定',
  completed: '完了済',
  cancelled: 'キャンセル',
};

export const PullDownVisitAppraisalReservationNextActionBy = {
  '': '全て',
  company: '不動産会社様の回答待ち',
  seller: '売主様の回答待ち',
};

export const VisitAppraisalReservationSortKey = {
  scheduled_at: '予約日',
  id: '予約ID',
};

export const PullDownVideoConsultationStatus = {
  '': '全て',
  proposing: '打診中',
  adjusting: '調整中',
  re_adjusting: '再調整中',
  confirmed: '確定',
  completed: '完了済',
  cancelled: 'キャンセル',
};

export const PullDownVideoConsultationNextActionBy = {
  '': '全て',
  company: '不動産会社様の回答待ち',
  seller: '売主様の回答待ち',
};

export const VideoConsultationSortKey = {
  scheduled_at: '予約日',
  id: '予約ID',
};

export const MediationContractCategory = {
  non_exclusive: '一般媒介',
  exclusive: '専任媒介',
  privileged_and_exclusive: '専属専任媒介',
  purchase: '買取',
};

export const PullDownMediationContractCategory = {
  '': '未選択',
  ...MediationContractCategory,
};

// 媒介契約報告一覧 - 媒介種類検索用
export const MediationAgreementCategorySearchOptions = {
  '': '全て',
  non_exclusive: '一般媒介',
  exclusive: '専任媒介',
  privileged_and_exclusive: '専属専任媒介',
};

// 媒介契約報告一覧 - ソートキー
export const MediationAgreementReportsSortKey = {
  created_at: '報告日',
  expiry_date: '有効期限',
};

// 媒介契約報告一覧 - 契約状況検索用
export const ContractStatusSearchOptions = {
  '': '全て',
  active: '契約中',
  terminated: '契約終了',
};

// 媒介契約報告一覧 - 契約終了理由検索用
export const TerminationReasonSearchOptions = {
  '': '全て',
  sold: '売買契約締結',
  sold_by_other_company: '他社成約',
  switched_to_other_company: '他社切替',
  listing_expired: '期限切れ',
  rented_out: '賃貸化',
  sale_canceled: '売却中止',
  sale_on_hold: '売却保留',
};

// 売買契約報告一覧 - 決済状況検索用
export const SettlementStatusSearchOptions = {
  '': '全て',
  settlement_date_unconfirmed: '決済日調整中',
  settlement_date_confirmed: '決済日調整完了',
  completed: '決済済み',
};

// 売買契約報告一覧 - 決済状況CheckBox検索用
export const SettlementStatusCheckboxOptions = {
  settlement_date_unconfirmed: '決済日調整中',
  settlement_date_confirmed: '決済日調整完了',
  completed: '決済済み',
};

// 売買契約報告一覧 - 取引タイプ検索用
export const DealTypeForAgreementReportsSearchOptions = {
  '': '全て',
  mediation: '仲介',
  purchase_other_company: '買取会社への仲介',
  purchase_in_house: '自社買取',
};

// 売買契約報告一覧 - ソートキー
export const AgreementReportsSortKey = {
  created_at: '報告日',
  settlement_date: '決済日',
};

// 並び順
export const SortOrderOptions = {
  '': '選択',
  asc: '昇順',
  desc: '降順',
};

export type PreferredTimingKeys = keyof typeof PreferredTiming;

//物件との関係
export const OwnerShip = {
  owner: '物件の名義人本人',
  family: '名義人の家族／親族',
  co_owner: '共有名義',
  agent: '物件所有者の了承を得た代理人',
};
export type OwnerShipKeys = keyof typeof OwnerShip;

//会社検索用propertyType
export const SearchCompaniesKeyPropertyType = {
  sale_case_count: '全て',
  sale_case_land: '土地',
  sale_case_mansion: 'マンション',
  sale_case_house: '一戸建て',
};

//会社検索用query
export const SearchCompanySortQueries = {
  sale_case_count: '地元の売却に強い',
  sale_case_mansion: 'マンションの売却に強い',
  sale_case_land: '土地の売却に強い',
  sale_case_house: '一戸建ての売却に強い',
  sale_case_land_house: '土地戸建の売却に強い',
  sale_case_purchase: '買取が得意',
  sell_high: '高く売るのが得意',
  sell_fast: '早く売るのが得意',
  not_decline: 'どんな物件も断らない',
  divorce: '離婚による売却が得意な',
  inheritance: '相続による売却が得意な',
};

//順番はデザイン通り
export const RegionDataList = {
  1: {
    name: '北海道・東北',
    prefectures: [1, 2, 3, 5, 4, 6, 7],
  },
  2: {
    name: '関東',
    prefectures: [13, 14, 11, 12, 8, 9, 10],
  },
  3: {
    name: '東海・甲信越・北陸',
    prefectures: [23, 21, 22, 24, 19, 20, 15, 16, 17, 18],
  },
  4: {
    name: '近畿',
    prefectures: [27, 28, 26, 25, 29, 30],
  },
  5: {
    name: '中国・四国',
    prefectures: [33, 34, 31, 32, 35, 37, 36, 38, 39],
  },
  6: {
    name: '九州・沖縄',
    prefectures: [40, 41, 42, 44, 43, 45, 46, 47],
  },
};

export const PrefecturesListWithoutSuffix: { [key: number]: string } = {
  1: '北海道',
  2: '青森',
  3: '岩手',
  4: '宮城',
  5: '秋田',
  6: '山形',
  7: '福島',
  8: '茨城',
  9: '栃木',
  10: '群馬',
  11: '埼玉',
  12: '千葉',
  13: '東京',
  14: '神奈川',
  15: '新潟',
  16: '富山',
  17: '石川',
  18: '福井',
  19: '山梨',
  20: '長野',
  21: '岐阜',
  22: '静岡',
  23: '愛知',
  24: '三重',
  25: '滋賀',
  26: '京都',
  27: '大阪',
  28: '兵庫',
  29: '奈良',
  30: '和歌山',
  31: '鳥取',
  32: '島根',
  33: '岡山',
  34: '広島',
  35: '山口',
  36: '徳島',
  37: '香川',
  38: '愛媛',
  39: '高知',
  40: '福岡',
  41: '佐賀',
  42: '長崎',
  43: '熊本',
  44: '大分',
  45: '宮崎',
  46: '鹿児島',
  47: '沖縄',
};
export const Prefectures: { [key: number]: string } = {
  1: '北海道',
  2: '青森県',
  3: '岩手県',
  4: '宮城県',
  5: '秋田県',
  6: '山形県',
  7: '福島県',
  8: '茨城県',
  9: '栃木県',
  10: '群馬県',
  11: '埼玉県',
  12: '千葉県',
  13: '東京都',
  14: '神奈川県',
  15: '新潟県',
  16: '富山県',
  17: '石川県',
  18: '福井県',
  19: '山梨県',
  20: '長野県',
  21: '岐阜県',
  22: '静岡県',
  23: '愛知県',
  24: '三重県',
  25: '滋賀県',
  26: '京都府',
  27: '大阪府',
  28: '兵庫県',
  29: '奈良県',
  30: '和歌山県',
  31: '鳥取県',
  32: '島根県',
  33: '岡山県',
  34: '広島県',
  35: '山口県',
  36: '徳島県',
  37: '香川県',
  38: '愛媛県',
  39: '高知県',
  40: '福岡県',
  41: '佐賀県',
  42: '長崎県',
  43: '熊本県',
  44: '大分県',
  45: '宮崎県',
  46: '鹿児島県',
  47: '沖縄県',
};
export const PublicPrefecturesWithAll: { [key: number]: string } = {
  0: '全国',
  1: '北海道',
  2: '青森県',
  3: '岩手県',
  4: '宮城県',
  5: '秋田県',
  6: '山形県',
  7: '福島県',
  8: '茨城県',
  9: '栃木県',
  10: '群馬県',
  11: '埼玉県',
  12: '千葉県',
  13: '東京都',
  14: '神奈川県',
  15: '新潟県',
  16: '富山県',
  17: '石川県',
  18: '福井県',
  19: '山梨県',
  20: '長野県',
  21: '岐阜県',
  22: '静岡県',
  23: '愛知県',
  24: '三重県',
  25: '滋賀県',
  26: '京都府',
  27: '大阪府',
  28: '兵庫県',
  29: '奈良県',
  30: '和歌山県',
  31: '鳥取県',
  32: '島根県',
  33: '岡山県',
  34: '広島県',
  35: '山口県',
  36: '徳島県',
  37: '香川県',
  38: '愛媛県',
  39: '高知県',
  40: '福岡県',
  41: '佐賀県',
  42: '長崎県',
  43: '熊本県',
  44: '大分県',
  45: '宮崎県',
  46: '鹿児島県',
  47: '沖縄県',
};

export const PrefecturalOfficeCoordinate: { [key: number]: number[] } = {
  1: [43.06417, 141.34694],
  2: [40.82444, 140.74],
  3: [39.70361, 141.1525],
  4: [38.26889, 140.87194],
  5: [39.71861, 140.1025],
  6: [38.24056, 140.36333],
  7: [37.75, 140.46778],
  8: [36.34139, 140.44667],
  9: [36.56583, 139.88361],
  10: [36.39111, 139.06083],
  11: [35.85694, 139.64889],
  12: [35.60472, 140.12333],
  13: [35.68944, 139.69167],
  14: [35.44778, 139.6425],
  15: [37.90222, 139.02361],
  16: [36.69528, 137.21139],
  17: [36.59444, 136.62556],
  18: [36.06528, 136.22194],
  19: [35.66389, 138.56833],
  20: [36.65139, 138.18111],
  21: [35.39111, 136.72222],
  22: [34.97694, 138.38306],
  23: [35.18028, 136.90667],
  24: [34.73028, 136.50861],
  25: [35.00444, 135.86833],
  26: [35.02139, 135.75556],
  27: [34.68639, 135.52],
  28: [34.69139, 135.18306],
  29: [34.68528, 135.83278],
  30: [34.22611, 135.1675],
  31: [35.50361, 134.23833],
  32: [35.47222, 133.05056],
  33: [34.66167, 133.935],
  34: [34.39639, 132.45944],
  35: [34.18583, 131.47139],
  36: [34.06583, 134.55944],
  37: [34.34028, 134.04333],
  38: [33.84167, 132.76611],
  39: [33.55972, 133.53111],
  40: [33.60639, 130.41806],
  41: [33.24944, 130.29889],
  42: [32.74472, 129.87361],
  43: [32.78972, 130.74167],
  44: [33.23806, 131.6125],
  45: [31.91111, 131.42389],
  46: [31.56028, 130.55806],
  47: [26.2125, 127.68111],
};

export const SELLER_TEL_REGEX = /^0(\d{9,10}|\d{1,4}-\d{3,5}-\d{4})$/;

export const CompanyProfileDataKeyList = [
  {
    title: 'title_first',
    body: 'body_first',
  },
  {
    title: 'title_second',
    body: 'body_second',
  },
  {
    title: 'title_third',
    body: 'body_third',
  },
  {
    title: 'title_fourth',
    body: 'body_fourth',
  },
  {
    title: 'title_fifth',
    body: 'body_fifth',
  },
  {
    title: 'title_sixth',
    body: 'body_sixth',
  },
  {
    title: 'title_seventh',
    body: 'body_seventh',
  },
  {
    title: 'title_eighth',
    body: 'body_eighth',
  },
  {
    title: 'title_ninth',
    body: 'body_ninth',
  },
  {
    title: 'title_tenth',
    body: 'body_tenth',
  },
] as const;

export type CompanyProfileDataTitleKeyLiteralList = typeof CompanyProfileDataKeyList[number]['title'];

export type CompanyProfileDataBodyKeyLiteralList = typeof CompanyProfileDataKeyList[number]['body'];

export const getCompaniesCityMetaTitle = (
  isValidUrl: boolean,
  prefectureName: string,
  cityName: string,
  queryTypeString: string,
) => {
  return isValidUrl
    ? `【${prefectureName}${cityName}版】の${queryTypeString}、おすすめの不動産屋さんランキング|「自分に合った」売却・買取・査定を実現する不動産売却専門サイト`
    : '';
};

export const PublicPropertyType = {
  mansion: '中古マンション',
  land: '土地',
  house: '中古一戸建て',
};

export const PublicTrendType = {
  flat: '横ばい',
  up: '上昇',
  strong_up: '急上昇',
  down: '下落',
  strong_down: '急下落',
};

export const PublicAreaTypes = {
  country: '全国',
  prefecture: '都道府県',
  city: '市区町村',
};

export type SalesStatCsvType = keyof typeof SalesStatCsvTypeText;

export const SalesStatCsvTypeText = {
  sales_stat: '売却の統計データ',
  real_estate_market: '不動産会社系相場動向',
  real_estate_market_detail: '価格系相場動向',
  property_feature: '高く売れる特徴',
  sales_stat_survey: 'アンケート',
  channel_ranking_page_link: 'チャンネルランキングページリンク',
  price_stats_area_stat: '価格統計エリア別データ',
  price_stats_town_stat: '価格統計町域別データ',
  price_stats_area_trend: '価格統計エリア推移データ',
};

export const LandTaxAssessmentMapUrl = 'https://www.rosenka.nta.go.jp/';

export const ReferralSellerPropertyType = {
  mansion: 'マンション',
  used_house: '戸建',
};

export const COMPANIES_SORT_TYPE_FOR_TOP_TITLES = {
  sale_case_mansion: 'マンションの売却に強い',
  sale_case_land: '土地の売却に強い',
  sale_case_house: '一戸建ての売却に強い',
  sell_high: '高く売るのが得意な',
  sell_fast: '早く売るのが得意な',
  not_decline: 'どんな物件も断らない',
  sale_case_purchase: '買取が得意な',
  divorce: '離婚による売却が得意な',
  inheritance: '相続による売却が得意な',
  leaseback: 'リースバックに対応できる',
  akiya: '空き家の売却が得意な',
};

export const AiAppraisalReportRequesterType = {
  AdminUser: '運営',
  CompanyUser: '不動産会社',
};

export const AiAppraisalReportAdminStatus = {
  inputting: '作成中',
  waiting_road_price_input: '路線価入力待ち',
  before_s3_upload: 'S3対応待ち',
  completed: '作成済み',
  failed: 'エラーあり',
  informed: 'メール送信済み',
};

export const AiAppraisalReportCompanyStatus = {
  inputting: '作成中',
  waiting_road_price_input: '作成中',
  before_s3_upload: '作成中',
  completed: '作成中',
  failed: 'エラーあり',
  informed: '作成済み',
};

export const AiAppraisalReportRoadPriceTypeLabel = {
  inheritance_tax: '相続税路線価',
  fixed_property_tax: '固定資産税路線価',
  none: '路線価なしで進める',
};

export const PenaltyApplicationStatusText = {
  draft: '下書き',
  unapproved: '申請中',
  approved: '承認済み',
  rejected: '却下',
} as const;

export const PenaltyLevelText = {
  foul: '注意',
  yellow: '警告',
  red: '危険',
  black: '利用停止',
} as const;

// 報告記録 - 報告経緯
export const ReportRecordReportedBy = {
  seller: '売主',
  company: '不動産会社',
  seller_and_company: '売主＆不動産会社',
};

// 報告記録 - 報告経緯（プルダウン用 - 未選択あり）
export const PullDownReportRecordReportedBy = {
  '': '未選択',
  ...ReportRecordReportedBy,
};

// 報告記録 - 催促の根拠
export const ReportRecordReminderEvidenceType = {
  tohon: '謄本',
  website: '掲載落ち',
  selling_chat: '売却相談チャット',
  sale_case: '売却実績',
  mediation_renewal: '媒介更新',
  on_site_appraisal: '訪問リスト',
  seller_report: '売主報告',
};

// 報告記録 - 催促の根拠（プルダウン用 - 未選択あり）
export const PullDownReportRecordReminderEvidenceType = {
  '': '未選択',
  ...ReportRecordReminderEvidenceType,
};

// 会社種別 (company_type) のAPIコード値
export const CompanyTypeCode = {
  generalAgency: 'general_agency',
  purchaseAgency: 'purchase_agency',
} as const;

export type CompanyTypeCodeValue = typeof CompanyTypeCode[keyof typeof CompanyTypeCode];

// AI査定書テンプレート (template_kind) の選択肢ラベル
export const AiAppraisalReportTemplateKindLabel = {
  v2_purchase_agency: '買取専門会社向け',
  v2_general_agency: '仲介会社向け',
} as const;

// 特殊フラグ - 物件特徴カテゴリーのキー
export const PropertyCharacteristicCategoryKeys = [
  'regulatory_constraints',
  'property_conditions',
  'land_characteristics',
  'ownership_rights',
  'support_services',
] as const;

export type PropertyCharacteristicCategoryKey = typeof PropertyCharacteristicCategoryKeys[number];

// 特殊フラグ - 物件特徴カテゴリーの表示ラベル
export const PropertyCharacteristicCategoryLabels: Record<PropertyCharacteristicCategoryKey, string> = {
  regulatory_constraints: '建築・法令・接道に関する制約',
  property_conditions: '物件状態・現地条件・告知事項',
  land_characteristics: '土地属性・エリア特性',
  ownership_rights: '権利関係・所有関係',
  support_services: '対応可能な周辺サポート',
};

export const ContractReportNoticeModalConfig = {
  storageKey: 'contract_report_notice_modal_confirmed_v1',
  endDate: '2026-06-20',
} as const;

export const CompanyCsCmsPageKey = {
  chatTemplate: 'chat_template',
} as const;
export type CompanyCsCmsPageKeyValue = typeof CompanyCsCmsPageKey[keyof typeof CompanyCsCmsPageKey];

// Article view / copy events are only sent for tabs opened from the seller chat button
export const ChatTipsActivityEvent = {
  clickButton: 'click_chat_tips_button',
  openTemplatePage: 'open_chat_template_page_from_seller_chat',
  copyTemplate: 'copy_chat_template_from_seller_chat',
} as const;

export const ChatTipsEntry = {
  queryKey: 'from',
  queryValue: 'seller_chat',
  storageKey: 'chat_tips_entry',
} as const;
